import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GetDynamicFormByID } from '../../store/NTX/FlexValue/Form/formSlice';

const useGetDynamicFormById = (id) => {
  const dispatch = useDispatch();
  const { DynamicFormListByID, loading2, error } = useSelector((state) => state.Forms);

  useEffect(() => {
    dispatch(GetDynamicFormByID(id));
  }, [dispatch, id]);

  return {
    DynamicFormListByID,
    loading: loading2,
    error,
  };
};

export default useGetDynamicFormById;
